import styled from 'styled-components';

export const RadioContainer = styled.section`
    margin: 20px 0;
`;
